import { render, staticRenderFns } from "./MDTP.vue?vue&type=template&id=511948fd&scoped=true"
import script from "./MDTP.vue?vue&type=script&lang=ts"
export * from "./MDTP.vue?vue&type=script&lang=ts"
import style0 from "./MDTP.vue?vue&type=style&index=0&id=511948fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511948fd",
  null
  
)

export default component.exports